<template>
<div class="animated fadeIn">
  <b-row>
    <b-col lg="12">
      <PapeleriaRequestsForm/>
    </b-col>
  </b-row>
</div>
</template>
<script>
import PapeleriaRequestsForm from '@/components/modules/papeleria/requests/alternative1'
export default {
  name: 'PapeleriaRequestsCreate',
  components: {
    PapeleriaRequestsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/requests/create.vue